"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDropdownSelector = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var theme_1 = __importDefault(require("../../../styles/theme"));
var objectUtilities_1 = require("../../../util/objectUtilities");
var DropdownSelector_style_1 = __importDefault(require("./DropdownSelector.style"));
function useDropdownSelector(_a) {
    var optionCategories = _a.optionCategories, selectedValue = _a.value, onSelect = _a.onSelect, getValueFriendlyName = _a.getValueFriendlyName, title = _a.title, defaultIcon = _a.defaultIcon, noValueOption = _a.noValueOption, _b = _a.placeholder, placeholder = _b === void 0 ? '' : _b, subMenuTitle = _a.subMenuTitle;
    var _c = __read((0, react_1.useState)(null), 2), anchorElement = _c[0], setAnchorElement = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isSubMenuOpen = _d[0], setIsSubMenuOpen = _d[1];
    var optionVariants = (0, react_1.useMemo)(function () { return (0, lodash_1.flatMap)(optionCategories, function (_a) {
        var variants = _a.variants;
        return variants;
    }); }, [optionCategories]);
    var selectedOptionCategory = (0, react_1.useMemo)(function () {
        return selectedValue
            ? optionCategories.find(function (_a) {
                var variants = _a.variants;
                return variants.find(function (_a) {
                    var value = _a.value;
                    return value.id === selectedValue.id;
                });
            })
            : undefined;
    }, [optionCategories, selectedValue]);
    var selectedValueVariant = (0, react_1.useMemo)(function () {
        return selectedValue ? selectedOptionCategory === null || selectedOptionCategory === void 0 ? void 0 : selectedOptionCategory.variants.find(function (_a) {
            var value = _a.value;
            return value.id === selectedValue.id;
        }) : undefined;
    }, [selectedOptionCategory === null || selectedOptionCategory === void 0 ? void 0 : selectedOptionCategory.variants, selectedValue]);
    var hasAvailableOptions = (function () {
        if (optionVariants.length === 1 && (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.id) === optionVariants[0].value.id && !noValueOption) {
            return false;
        }
        return !!optionVariants.length;
    })();
    var closePopover = function () { return setAnchorElement(null); };
    var onClickWithClosePopover = (0, react_1.useCallback)(function (onClick) { return function () {
        onClick();
        closePopover();
    }; }, []);
    var convertGroupTitlesIntoVariants = (0, react_1.useCallback)(function () {
        return (0, objectUtilities_1.filterMap)(optionCategories, function (_a) {
            var title = _a.title, variants = _a.variants;
            if (!title || !variants.length) {
                return false;
            }
            var defaultValue = (variants.find(function (_a) {
                var displayText = _a.displayText;
                return displayText === (selectedValueVariant === null || selectedValueVariant === void 0 ? void 0 : selectedValueVariant.displayText);
            }) || variants[0]).value;
            return {
                selected: title === (selectedOptionCategory === null || selectedOptionCategory === void 0 ? void 0 : selectedOptionCategory.title),
                onClick: onClickWithClosePopover(function () { return onSelect(defaultValue); }),
                value: defaultValue,
                displayText: title,
            };
        });
    }, [
        onClickWithClosePopover,
        onSelect,
        optionCategories,
        selectedOptionCategory === null || selectedOptionCategory === void 0 ? void 0 : selectedOptionCategory.title,
        selectedValueVariant === null || selectedValueVariant === void 0 ? void 0 : selectedValueVariant.displayText,
    ]);
    var groupedOptionExtended = (0, react_1.useMemo)(function () {
        return subMenuTitle
            ? {
                variants: convertGroupTitlesIntoVariants(),
                iconProps: defaultIcon,
            }
            : undefined;
    }, [convertGroupTitlesIntoVariants, defaultIcon, subMenuTitle]);
    var valueOptionsExtended = (0, react_1.useMemo)(function () {
        return (0, objectUtilities_1.filterMap)(optionCategories, function (_a) {
            var variants = _a.variants, title = _a.title, rest = __rest(_a, ["variants", "title"]);
            var variantsExtended = (0, objectUtilities_1.filterMap)(variants, function (_a) {
                var value = _a.value, rest = __rest(_a, ["value"]);
                if (subMenuTitle && title !== (selectedOptionCategory === null || selectedOptionCategory === void 0 ? void 0 : selectedOptionCategory.title)) {
                    return null;
                }
                return __assign({ selected: value.id === (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.id), onClick: onClickWithClosePopover(function () { return onSelect(value); }), value: value }, rest);
            });
            return (!!variantsExtended.length && __assign(__assign({}, rest), { title: subMenuTitle ? undefined : title, variants: variantsExtended }));
        });
    }, [subMenuTitle, onClickWithClosePopover, onSelect, optionCategories, selectedOptionCategory === null || selectedOptionCategory === void 0 ? void 0 : selectedOptionCategory.title, selectedValue]);
    var optionCategoriesExtended = groupedOptionExtended
        ? [groupedOptionExtended]
        : valueOptionsExtended;
    var groupSubMenuCategoriesExtended = subMenuTitle ? valueOptionsExtended : [];
    var noValueOptionExtended = noValueOption
        ? __assign(__assign({}, noValueOption), { clearSelection: onClickWithClosePopover(noValueOption.clearSelection), selected: selectedValue === undefined }) : undefined;
    var openPopover = (0, react_1.useCallback)(function (subMenuActive) {
        return hasAvailableOptions
            ? function (event) {
                setIsSubMenuOpen(subMenuActive);
                setAnchorElement(event.currentTarget);
            }
            : undefined;
    }, [hasAvailableOptions]);
    var popoverOpeners = (0, react_1.useMemo)(function () {
        var _a, _b;
        var categoryIcon = selectedOptionCategory === null || selectedOptionCategory === void 0 ? void 0 : selectedOptionCategory.iconProps;
        if (!subMenuTitle) {
            var icon_1 = __assign({ color: theme_1.default.colors.dark }, (categoryIcon || defaultIcon));
            var valueText_1 = selectedValue ? (_a = getValueFriendlyName === null || getValueFriendlyName === void 0 ? void 0 : getValueFriendlyName(selectedValue)) !== null && _a !== void 0 ? _a : selectedValue : placeholder;
            var titleText_1 = "".concat(title).concat(valueText_1 ? ':' : '');
            return [
                {
                    valueText: valueText_1,
                    titleText: titleText_1,
                    openPopover: openPopover(false),
                    icon: icon_1,
                    chevronOpen: true,
                    renderedChevron: hasAvailableOptions,
                },
            ];
        }
        var icon = __assign({ color: theme_1.default.colors.dark }, ((selectedValueVariant === null || selectedValueVariant === void 0 ? void 0 : selectedValueVariant.iconProps) || categoryIcon || defaultIcon));
        var valueText = selectedValue ? (_b = selectedOptionCategory === null || selectedOptionCategory === void 0 ? void 0 : selectedOptionCategory.title) !== null && _b !== void 0 ? _b : selectedValue : placeholder;
        var titleText = "".concat(title).concat(valueText ? ':' : '');
        var subMenuValueText = (selectedValueVariant === null || selectedValueVariant === void 0 ? void 0 : selectedValueVariant.displayText) || '-';
        var subMenuTitleText = "".concat(subMenuTitle).concat(subMenuValueText ? ':' : '');
        var isMenuOpenable = optionCategories.length > 1;
        var isSubMenuOpenable = hasAvailableOptions && ((selectedOptionCategory === null || selectedOptionCategory === void 0 ? void 0 : selectedOptionCategory.variants.length) || 0) > 1;
        return [
            {
                valueText: valueText,
                titleText: titleText,
                openPopover: isMenuOpenable ? openPopover(false) : undefined,
                icon: __assign({ color: theme_1.default.colors.dark }, (categoryIcon || defaultIcon)),
                chevronOpen: !isSubMenuOpen,
                renderedChevron: isMenuOpenable,
            },
            {
                valueText: subMenuValueText,
                titleText: subMenuTitleText,
                openPopover: isSubMenuOpenable ? openPopover(true) : undefined,
                icon: icon,
                chevronOpen: isSubMenuOpen,
                renderedChevron: isSubMenuOpenable,
            },
        ];
    }, [
        selectedOptionCategory === null || selectedOptionCategory === void 0 ? void 0 : selectedOptionCategory.iconProps,
        selectedOptionCategory === null || selectedOptionCategory === void 0 ? void 0 : selectedOptionCategory.title,
        selectedOptionCategory === null || selectedOptionCategory === void 0 ? void 0 : selectedOptionCategory.variants.length,
        subMenuTitle,
        selectedValueVariant === null || selectedValueVariant === void 0 ? void 0 : selectedValueVariant.iconProps,
        selectedValueVariant === null || selectedValueVariant === void 0 ? void 0 : selectedValueVariant.displayText,
        defaultIcon,
        selectedValue,
        placeholder,
        title,
        hasAvailableOptions,
        optionCategories.length,
        openPopover,
        isSubMenuOpen,
        getValueFriendlyName,
    ]);
    return {
        classes: (0, DropdownSelector_style_1.default)(),
        closePopover: closePopover,
        anchorElement: anchorElement,
        optionCategoriesExtended: optionCategoriesExtended,
        noValueOptionExtended: noValueOptionExtended,
        groupSubMenuCategoriesExtended: groupSubMenuCategoriesExtended,
        isSubMenuOpen: isSubMenuOpen,
        popoverOpeners: popoverOpeners,
    };
}
exports.useDropdownSelector = useDropdownSelector;
